import * as CryptoJS from 'crypto-js'

const iv = CryptoJS.enc.Utf8.parse('FrlTQArFGFA9EweP')
const key = CryptoJS.enc.Utf8.parse('nkxSZBo3XOVeWtn7')

export const encryptText = (value) => {
    let encText = CryptoJS.AES.encrypt(value, key, { iv: iv })  
    return encText.toString()
}
